import { QueryClient } from "@tanstack/react-query";

const LIBRARY_QUERY_KEYS = [
    "frontend-library-list",
    "library-documents",
    "frontend-library-folders",
] as const;

export function invalidateLibraryQueries(queryClient: QueryClient) {
    for (const key of LIBRARY_QUERY_KEYS) {
        queryClient.invalidateQueries({ queryKey: [key] });
    }
}
